import { Axios, AxiosError } from 'axios'
import {
  ChangePasswordRequest,
  ChangePasswordResponse,
  ForgotPasswordRequest,
  ForgotPasswordResponse,
  LoginRequest,
  LoginResponse,
  RegisterUserRequest,
  RegisterUserResponse,
  ResetPasswordRequest,
  ResetPasswordResponse,
} from '../types/Login'
import idServerApi from './idServerApi'
import { queryClient } from '../queries/client'
import { QueryFunctionContext } from 'react-query'
import { decodeAuthToken } from '../utils/auth'
import { getAuthStore } from '../store/useAuthStore'

const API_URL = process.env.REACT_APP_API_URL
const ID_SERVER_API_URL = process.env.REACT_APP_ID_SERVER_URL
export const GET_USER_BY_ACCESSTOKEN_URL = `${API_URL}/verify_token`
export const LOGIN_URL = `${ID_SERVER_API_URL}/auth/login`
export const REGISTER_URL = `${API_URL}/auth/register`
// export const REGISTER_URL = `${API_URL}/register`
export const FORGOT_PASSWORD_URL = `${ID_SERVER_API_URL}/v1/auth/forgotPassword`
export const RESET_PASSWORD_URL = `${ID_SERVER_API_URL}/v1/auth/resetPassword`
export const CHANGE_PASSWORD_URL = `${ID_SERVER_API_URL}/v1/auth/changePassword`

export async function login(credentials: LoginRequest): Promise<LoginResponse> {
  return idServerApi.post(LOGIN_URL, credentials)
}

export async function logout(data: any): Promise<void> {
  return idServerApi.post(`${ID_SERVER_API_URL}/auth/logout`, undefined)
}

export async function checkHeartBeat() {
  return idServerApi
    .get('auth/heartbeat')
    .then((res: any) => {
      if (res.data.data) {
        const user = sessionStorage.getItem('accessToken')
        const userPayload = decodeAuthToken(user!)
        if (user && res.data.data.toString() !== userPayload.id.toString()) {
          sessionStorage.clear()
          queryClient.clear()
          getAuthStore().clearAuthorization()
          window.location.reload()
        }
      }
      return res.data.data
    })
    .catch((error: AxiosError) => {
      sessionStorage.clear()
      queryClient.clear()
      window.location.href = '/auth/login'
    })
}

export async function refetchAccessToken() {
  return idServerApi.get('auth/token').then((res: any) => {
    sessionStorage.setItem('accessToken', res.data)
    return res.data
  })
}

export async function forgotPassword(
  credentials: ForgotPasswordRequest
): Promise<ForgotPasswordResponse> {
  return idServerApi.post(FORGOT_PASSWORD_URL, credentials)
}
export async function resetPassword(
  credentials: ResetPasswordRequest
): Promise<ResetPasswordResponse> {
  return idServerApi.post(RESET_PASSWORD_URL, credentials, {
    headers: { authorization: credentials.jwt },
  })
}

export async function changePassword(
  credentials: ChangePasswordRequest
): Promise<ChangePasswordResponse> {
  return idServerApi.post(CHANGE_PASSWORD_URL, credentials, {
    headers: { authorization: credentials.jwt },
  })
}

export async function registration(
  credentials: RegisterUserRequest
): Promise<RegisterUserResponse> {
  return idServerApi.post(REGISTER_URL, credentials)
}

export async function getPlatformInfo(context: QueryFunctionContext): Promise<any> {
  const accesstoken = context.queryKey[1] as string
  return idServerApi
    .get(`auth/user/platform`, {
      headers: {
        accesstoken,
      },
    })
    .then((res: any) => res.data.data)
}
